import {
  Autocomplete,
  Button,
  Card,
  Container,
  Grid,
  IconButton,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  Stack,
  tableCellClasses,
  TextField,
  Tooltip,
  Typography,
  FormControlLabel,
  InputAdornment
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import TuneIcon from '@mui/icons-material/Tune';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import CloseIcon from '@mui/icons-material/Close';
import { useForm, useWatch, useFieldArray, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { Box } from '@mui/system';
import { useCallback, useEffect, useState } from 'react';
import { AiFillCloseCircle, AiFillEdit, AiOutlineMinus } from 'react-icons/ai';
import { useDispatch } from 'react-redux';
import { MdModeEdit, MdOutlineAdd, MdOutlineUpdate } from 'react-icons/md';
import { useLocation, useNavigate } from 'react-router-dom';
import { format } from 'date-fns';
import { ExcelRenderer } from 'react-excel-renderer';
import { BiCloudDownload, BiCloudUpload } from 'react-icons/bi';
import BrudCrumbs from '../../components/BreadCrumbs';
import Page from '../../components/Page';
import PageTitle from '../../components/PageHeading';
import useLoginSelector from '../../store/Slice/Login/LoginSelector';
import useGlobalSelector from '../../store/Slice/Global/GlobalSelector';
import {
  getBankDropdownData,
  getLoanTypeData,
  saveApiData
} from '../../store/Slice/Global/GlobalSlice';
import { StyledIconButton, StyledTableRow } from '../../utils/StyleTable';
import useOnboardingSelector from '../../store/Slice/Onboarding/OnboardingSelector';
import { getOnboardingShowData } from '../../store/Slice/Onboarding/OnboardingSlice';
import { OnboardingApi, UserApi } from '../../utils/Apis';
import CustomInput from '../../components/CustomInput';
import CustomSelect from '../../components/CustomSelect';
import { setApiError, setApiSuccess } from '../../store/Slice/Error/ErrorSlice';
import RevenueService from '../services/RevenueService';
import { getIncentiveList } from '../../store/Slice/User/UserSlice';
import useUserSelector from '../../store/Slice/User/UserSelector';
import { savefileApiData } from '../../store/Slice/Payout/PayoutSlice';

const validationSchema = yup.object().shape({
  partnerCommission: yup
    .array()
    .of(
      yup
        .object()
        .shape({
          bankId: yup.string().required('Please select bank name'),
          loanTypeId: yup.string().required('Please select loan type'),
          companyCommition: yup
            .number()
            .typeError('Type company commission %')
            .required('Type company commission %')
            .min(0, 'Commission cannot be negative')
            .max(100, 'Commission cannot exceed 100%'),
          partnerCommition: yup
            .number()
            .typeError('Type partner share %')
            .required('Type partner share %')
            .min(0, 'Partner share cannot be negative')
            .max(100, 'Partner share cannot exceed 100%')
        })
        .test(
          'total-not-greater-than-100',
          'Sum of Company Commission & Partner Share should not be greater than 100%',
          function (item) {
            const total = Number(item.companyCommition || 0) + Number(item.partnerCommition || 0);
            if (total > 100) {
              return this.createError({
                path: `${this.path}.partnerCommition`, // attach error to partnerCommition
                message: 'Sum of Company Commission & Partner Share should not be greater than 100%'
              });
            }
            return true;
          }
        )
    )
    .min(1, 'At least one partner commission entry is required')
});

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    fontSize: 12,
    padding: '6px',
    height: '42.5px',
    fontWeight: 500,
    textTransform: 'uppercase',
    color: '#0d4689'
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 11,
    padding: '4px 6px',
    height: '42.5px'
  }
}));

function SetIncentiveForEmployeePartner() {
  const [editcomm, setEditcomm] = useState('');
  const [autosugval, setAutosugval] = useState({
    loanTypeId: '',
    companyCommition: '',
    partnerCommition: ''
  });
  const [downloadTemplateMsg, setDownloadTemplateMsg] = useState('');

  const dispatch = useDispatch();
  const location = useLocation();
  const { rowId } = location?.state || {};
  // console.log('rowIdrowIdrowId', rowId);
  const { LoginData } = useLoginSelector();
  const { OnboardingShowCommision } = useOnboardingSelector();
  const { BankDrop, LoanTypeDrop } = useGlobalSelector();
  const [selection, setSelection] = useState('manually');
  const [file, setFile] = useState(null);
  const [selectedFileName, setSelectedFileName] = useState('');
  const [openDownloadTemplateDialog, setOpenDownloadTemplateDialog] = useState(false);
  const [uploadfile, setUploadfile] = useState(null);
  const [openLoader, setOpenLoader] = useState(false);
  const [open, setOpen] = useState(false);
  const [targetSlbsArray, setTargetSlbsArray] = useState([
    {
      minAmount: null,
      maxAmount: null,
      incentivePercent: null
    }
  ]);

  const [disburseSlbsArray, setdisburseSlbsArray] = useState([
    {
      bankName: null,
      loanType: null,
      incentivePercent: null
    }
  ]);

  const getLoanMasterApi = useCallback(() => {
    // console.log('getLoanMasterApi called, LoginData:', LoginData);

    if (!LoginData?.companyId || !LoginData?.userId) {
      console.log('LoginData not available yet');
      return;
    }

    // console.log('Calling getLoanTypeData API with:', {
    //   companyId: LoginData.companyId,
    //   userId: LoginData.userId
    // });

    const obj = {
      companyId: LoginData.companyId,
      userId: LoginData.userId
    };
    dispatch(getLoanTypeData(obj));
  }, [LoginData, dispatch]);

  useEffect(() => {
    // console.log('useEffect running, calling getLoanMasterApi');
    getLoanMasterApi();
  }, [getLoanMasterApi]);

  const navigate = useNavigate();

  // console.log('LoanTypeData222:', LoanTypeDrop);
  // console.log('BankDrop222:', BankDrop);

  const newBankDrop = [{ label: 'All', value: 0 }, ...(BankDrop || [])] || [];
  const newMasterLoanTypeDrop = [{ label: 'All', value: 0 }, ...(LoanTypeDrop || [])] || [];
  const {
    control,
    handleSubmit,
    watch,
    resetField,
    formState: { errors }
  } = useForm({
    defaultValues: {
      incentiveType: '',
      incentiveDuration: '',
      targetSlabs: [{ minAmount: '', maxAmount: '', incentivePercent: '' }],
      disbursementConfigs: [{ bankName: '', loanType: '', incentivePercent: '' }]
    }
  });

  const {
    fields: targetFields,
    append: appendTarget,
    remove: removeTarget
  } = useFieldArray({
    control,
    name: 'targetSlabs'
  });

  const {
    fields: disburseFields,
    append: appendDisburse,
    remove: removeDisburse
  } = useFieldArray({
    control,
    name: 'disbursementConfigs'
  });

  const { DownloadIncentiveTemplate } = RevenueService;

  const incentiveTypeValue = useWatch({
    control,
    name: 'incentiveType'
  });

  const compnayPercen = useWatch({
    control,
    name: 'companyPercentage'
  });

  const DurationValue = useWatch({
    control,
    name: 'incentiveDuration'
  });

  useEffect(() => {
    console.log('Selected Incentive Type:', incentiveTypeValue);
  }, [incentiveTypeValue]);

  const onSubmit = async (formData) => {
    let payload;

    if (formData.incentiveType === 'TARGET_BASED') {
      payload = {
        employeeId: rowId,
        userId: LoginData?.userId,
        incentiveType: 'TARGET_BASED',
        duration: formData.incentiveDuration,
        companyPercentage: formData.companyPercentage,
        targetSlabs: formData.targetSlabs.map((item) => ({
          ...item,
          incentivePercent: Number(item.incentivePercent)
        }))
      };
    }

    if (formData.incentiveType === 'DISBURSEMENT_BASED') {
      payload = {
        employeeId: rowId,
        userId: LoginData?.userId,
        incentiveType: 'DISBURSEMENT_BASED',
        duration: formData.incentiveDuration,
        companyPercentage: formData.companyPercentage,
        disbursementConfigs: formData.disbursementConfigs.map((item) => ({
          ...item,
          incentivePercent: Number(item.incentivePercent)
        }))
      };
    }

    const result = await dispatch(saveApiData(UserApi.createIncentive, payload));

    if (result?.status === 'success') {
      dispatch(setApiSuccess('Successfully added new Record'));
      getIncentiveData();
    }
  };

  const getBankDropApi = useCallback(() => {
    if (!LoginData) return;
    const data = { companyId: LoginData?.companyId, userId: LoginData?.userId };
    dispatch(getBankDropdownData(data));
  }, [dispatch, LoginData]);

  const getOnboardingShowDataApi = useCallback(() => {
    if (!LoginData && !rowId) return;
    const data = {
      companyId: LoginData?.companyId,
      partnerId: rowId?.partnerId || rowId,
      sortOrder: 'asc'
    };
    dispatch(getOnboardingShowData(data));
  }, [rowId, LoginData]);

  useEffect(() => {
    getBankDropApi();
  }, [getBankDropApi]);

  useEffect(() => {
    getOnboardingShowDataApi();
  }, [getOnboardingShowDataApi]);

  const handleRadioChange = (event) => {
    setSelection(event.target.value);
    setFile(null); // reset file if radio changes
  };

  const handleRenderFile = (fileObj) => {
    ExcelRenderer(fileObj, (err, resp) => {
      if (err) {
        console.error('Error reading excel file', err);
        setOpenLoader(false);
        return;
      }
      // If you need to process `resp.rows`, do it here…
      setOpenLoader(false);
    });
  };

  // SIMPLE, SAFE FILE HANDLER
  const handleFileChange = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    const fileName = file.name;
    const ext = fileName.slice(fileName.lastIndexOf('.') + 1).toLowerCase();

    setSelectedFileName(fileName);
    setUploadfile(file);

    if (ext === 'xlsx' || ext === 'xls' || ext === 'csv') {
      setOpenLoader(true);
      handleRenderFile(file);
    } else {
      // reset file if wrong type
      setUploadfile(null);
      setSelectedFileName('');
      setOpen(true);
      dispatch(setApiError('Please add only xlsx/csv/xls file only'));
    }
  };

  const handleDownloadTemplate = async (type) => {
    // console.log('Selected:', type);
    const path = {
      incentiveType: incentiveTypeValue
    };

    try {
      const response = await DownloadIncentiveTemplate(path, path, LoginData?.jwt);

      const contentType = response.headers.get('content-type');
      // console.log('content-type =>', contentType);

      const blob = await response.blob();
      // console.log('response222', blob);
      let fileName = `${incentiveTypeValue}-IncentiveDownload_${format(
        new Date(),
        'dd-MM-yyyy_HH-mm-ss'
      )}`;
      let mimeType = contentType;

      fileName += '.xlsx';
      mimeType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

      const url = window.URL.createObjectURL(new Blob([blob], { type: mimeType }));

      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Export error:', error);
    }
  };

  const { IncentiveListData } = useUserSelector();

  const getIncentiveData = useCallback(() => {
    dispatch(getIncentiveList(rowId));
  }, [dispatch, rowId]);

  useEffect(() => {
    getIncentiveData();
  }, [getIncentiveData]);

  const uploadSubmit = async (e) => {
    // e.preventDefault();
    if (!DurationValue) {
      setOpen(true);
      dispatch(setApiError('Please Select Duration Dropdown'));
      return;
    }
    if (!uploadfile) {
      setOpen(true);
      dispatch(setApiError('Please upload MIS file'));
      return;
    }

    const formUploadData = new FormData();
    formUploadData.append('employeeId', rowId);
    formUploadData.append('incentiveType', incentiveTypeValue);
    formUploadData.append('duration', DurationValue);
    formUploadData.append('createdBy', 146);
    formUploadData.append('file', uploadfile);
    formUploadData.append('companyPercent', compnayPercen);

    const result = await dispatch(
      savefileApiData(UserApi?.uploadIncentive, formUploadData, LoginData?.jwt)
    );
    if (result?.data?.status === 'success') {
      dispatch(setApiSuccess(result?.data?.message || 'Uploaded Successfully'));
      getIncentiveData();
    }
    // console.log('sss upload result', result);
  };

  function handleIncentiveType() {
    setUploadfile(null);
    setSelectedFileName('');
    setFile(null);
    resetField('incentiveDuration');
  }

  function handleClose() {
    setSelectedFileName(() => null);
  }

  return (
    <Page title="Kpros by Kalolytic Solutions || On Boarding">
      <Box sx={{ bgcolor: '#f8fafc', minHeight: '100vh', pb: 8, pt: 2.5 }}>
        <Container maxWidth="xl">
          {/* Header */}
          <Box sx={{ mb: 3 }}>
            <Button
              startIcon={<ArrowBackIcon />}
              onClick={() => navigate('/users')}
              sx={{
                color: '#64748b',
                fontWeight: 600,
                fontSize: '0.875rem',
                textTransform: 'none',
                mb: 1.5,
                p: 0,
                '&:hover': { color: '#0f172a', bgcolor: 'transparent' }
              }}
            >
              Back to Users
            </Button>
            <Stack
              direction={{ xs: 'column', md: 'row' }}
              justifyContent="space-between"
              alignItems={{ xs: 'flex-start', md: 'center' }}
              spacing={2}
            >
              <Box>
                <Typography
                  variant="h4"
                  sx={{
                    color: '#0f172a',
                    fontWeight: 800,
                    fontSize: { xs: '1.5rem', md: '1.75rem' },
                    letterSpacing: '-0.02em',
                    mb: 0.5
                  }}
                >
                  Set Incentive
                </Typography>
                <Typography variant="body2" sx={{ color: '#64748b' }}>
                  Configure employee and partner incentive slabs, duration, and commission
                  structures
                </Typography>
              </Box>
              <Box>
                <BrudCrumbs />
              </Box>
            </Stack>
          </Box>

          {/* Incentive Type Selection Card */}
          <Card
            sx={{
              borderRadius: '16px',
              border: '1px solid #e2e8f0',
              boxShadow: '0 4px 20px rgba(0,0,0,0.03)',
              p: { xs: 2.5, md: 3 },
              bgcolor: '#ffffff',
              mb: 3
            }}
          >
            <Stack
              direction="row"
              alignItems="center"
              spacing={1.5}
              sx={{ mb: 2.5, pb: 2, borderBottom: '1px solid #f1f5f9' }}
            >
              <Box
                sx={{
                  width: 34,
                  height: 34,
                  borderRadius: '8px',
                  bgcolor: '#0284c7',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: '#ffffff'
                }}
              >
                <TuneIcon sx={{ fontSize: 18 }} />
              </Box>
              <Box>
                <Typography sx={{ fontSize: '1rem', fontWeight: 700, color: '#0f172a' }}>
                  Incentive Model
                </Typography>
                <Typography sx={{ fontSize: '0.75rem', color: '#64748b' }}>
                  Select the calculation model for this partner
                </Typography>
              </Box>
            </Stack>

            <Grid container spacing={3}>
              <Grid item xs={12} sm={6} md={4}>
                <CustomSelect
                  name="incentiveType"
                  label="Incentive Type"
                  control={control}
                  errors={errors}
                  onChange={() => handleIncentiveType()}
                  isRequired
                  options={[
                    { label: 'Target Based', value: 'TARGET_BASED' },
                    { label: 'Disbursement Based', value: 'DISBURSEMENT_BASED' }
                  ]}
                />
              </Grid>
            </Grid>
          </Card>

          {/* TARGET BASED SECTION */}
          {incentiveTypeValue === 'TARGET_BASED' && (
            <Card
              sx={{
                borderRadius: '16px',
                border: '1px solid #e2e8f0',
                boxShadow: '0 4px 20px rgba(0,0,0,0.03)',
                p: { xs: 2.5, md: 3 },
                bgcolor: '#ffffff',
                mb: 3
              }}
            >
              <Stack
                direction="row"
                alignItems="center"
                spacing={1.5}
                sx={{ mb: 2.5, pb: 2, borderBottom: '1px solid #f1f5f9' }}
              >
                <Box
                  sx={{
                    width: 34,
                    height: 34,
                    borderRadius: '8px',
                    bgcolor: '#0284c7',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: '#ffffff'
                  }}
                >
                  <TrendingUpIcon sx={{ fontSize: 18 }} />
                </Box>
                <Box>
                  <Typography sx={{ fontSize: '1rem', fontWeight: 700, color: '#0f172a' }}>
                    Target Based Loan Requirement
                  </Typography>
                  <Typography sx={{ fontSize: '0.75rem', color: '#64748b' }}>
                    Configure target slabs, frequency, and percentage sharing
                  </Typography>
                </Box>
              </Stack>

              <RadioGroup
                row
                value={selection}
                onChange={handleRadioChange}
                sx={{
                  mb: 3,
                  '& .MuiRadio-root': {
                    color: '#94a3b8',
                    '&.Mui-checked': {
                      color: '#0284c7'
                    }
                  },
                  '& .MuiFormControlLabel-label': {
                    fontWeight: 600,
                    fontSize: '0.875rem',
                    color: '#334155'
                  }
                }}
              >
                <FormControlLabel value="manually" control={<Radio />} label="Manually" />
                <FormControlLabel value="upload" control={<Radio />} label="Upload" />
              </RadioGroup>

              <Grid container spacing={3} mb={3}>
                <Grid item xs={12} sm={6} md={4}>
                  <CustomSelect
                    name="incentiveDuration"
                    label="Incentive Duration"
                    control={control}
                    errors={errors}
                    isRequired
                    options={[
                      { label: 'Monthly', value: 'MONTHLY' },
                      { label: 'Quarterly', value: 'QUARTERLY' },
                      { label: 'Yearly', value: 'YEARLY' }
                    ]}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <CustomInput
                    name="companyPercentage"
                    label="Company Percentage %"
                    control={control}
                    errors={errors}
                    type="number"
                    isRequired
                  />
                </Grid>
              </Grid>

              {selection === 'manually' && (
                <form onSubmit={handleSubmit(onSubmit)}>
                  {targetFields.map((item, index) => (
                    <Grid container spacing={2} key={item.id} alignItems="flex-end" mb={2}>
                      <Grid item xs={12} sm={4}>
                        <CustomInput
                          name={`targetSlabs.${index}.minAmount`}
                          label="Min Amount"
                          control={control}
                          errors={errors?.targetSlabs?.[index]}
                          type="number"
                          isRequired
                        />
                      </Grid>

                      <Grid item xs={12} sm={3}>
                        <CustomInput
                          name={`targetSlabs.${index}.maxAmount`}
                          label="Max Amount"
                          control={control}
                          errors={errors?.targetSlabs?.[index]}
                          type="number"
                          isRequired
                        />
                      </Grid>

                      <Grid item xs={12} sm={3}>
                        <Controller
                          name={`targetSlabs.${index}.incentivePercent`}
                          control={control}
                          defaultValue=""
                          render={({ field }) => (
                            <Box>
                              <Typography variant="h6" className="formLabel">
                                Incentive % <span style={{ color: 'red' }}>*</span>
                              </Typography>
                              <TextField
                                {...field}
                                fullWidth
                                placeholder="Enter Incentive %"
                                inputProps={{
                                  maxLength: 2,
                                  inputMode: 'numeric',
                                  pattern: '[0-9]*',
                                  className: 'textInput'
                                }}
                                onChange={(e) => {
                                  const value = e.target.value.replace(/[^0-9]/g, '');
                                  if (value.length > 2) return;
                                  field.onChange(value);
                                }}
                                InputProps={{
                                  endAdornment: <InputAdornment position="end">%</InputAdornment>
                                }}
                              />
                            </Box>
                          )}
                        />
                      </Grid>

                      <Grid item xs={12} sm={2} display="flex" gap={1} pb={0.5}>
                        <IconButton
                          onClick={() =>
                            appendTarget({
                              minAmount: '',
                              maxAmount: '',
                              incentivePercent: ''
                            })
                          }
                          sx={{
                            bgcolor: '#e0f2fe',
                            color: '#0284c7',
                            borderRadius: '8px',
                            '&:hover': { bgcolor: '#bae6fd' }
                          }}
                        >
                          <MdOutlineAdd />
                        </IconButton>

                        {targetFields.length > 1 && (
                          <IconButton
                            onClick={() => removeTarget(index)}
                            sx={{
                              bgcolor: '#fee2e2',
                              color: '#ef4444',
                              borderRadius: '8px',
                              '&:hover': { bgcolor: '#fecaca' }
                            }}
                          >
                            <AiOutlineMinus />
                          </IconButton>
                        )}
                      </Grid>
                    </Grid>
                  ))}

                  <Box mt={3} textAlign="right">
                    <Button
                      variant="contained"
                      type="submit"
                      sx={{
                        bgcolor: '#0284c7',
                        color: '#ffffff',
                        borderRadius: '8px',
                        textTransform: 'none',
                        fontWeight: 600,
                        px: 3.5,
                        py: 1,
                        boxShadow: '0 4px 12px rgba(2, 132, 199, 0.25)',
                        '&:hover': {
                          bgcolor: '#0369a1',
                          boxShadow: '0 6px 16px rgba(2, 132, 199, 0.35)'
                        }
                      }}
                    >
                      Submit
                    </Button>
                  </Box>
                </form>
              )}

              {selection === 'upload' && (
                <Grid container alignItems="center" spacing={3}>
                  <Grid item xs={12} md={8}>
                    <Box
                      sx={{
                        border: '2px dashed #cbd5e1',
                        borderRadius: '12px',
                        p: 3,
                        textAlign: 'center',
                        bgcolor: '#f8fafc',
                        cursor: 'pointer',
                        transition: 'all 0.2s',
                        '&:hover': {
                          borderColor: '#0284c7',
                          bgcolor: '#f0f9ff'
                        }
                      }}
                    >
                      <input
                        accept=".xlsx, .xls, .csv"
                        className="fileInput"
                        id="contained-button-file"
                        multiple
                        type="file"
                        style={{ display: 'none' }}
                        onChange={handleFileChange}
                      />
                      <label
                        htmlFor="contained-button-file"
                        style={{ cursor: 'pointer', display: 'block' }}
                      >
                        <Box>
                          {selectedFileName ? (
                            <Typography variant="body2" sx={{ color: '#0f172a', fontWeight: 600 }}>
                              {`Selected file: ${selectedFileName}`}
                              <IconButton
                                onClick={(e) => {
                                  e.preventDefault();
                                  e.stopPropagation();
                                  handleClose();
                                }}
                                size="small"
                                sx={{
                                  color: '#0284c7',
                                  backgroundColor: '#e0f2fe',
                                  ml: 1,
                                  '&:hover': { backgroundColor: '#bae6fd' }
                                }}
                              >
                                <CloseIcon fontSize="small" />
                              </IconButton>
                            </Typography>
                          ) : (
                            <>
                              <BiCloudUpload size={36} color="#0284c7" />
                              <Typography
                                variant="h6"
                                sx={{ color: '#0f172a', mt: 1, fontWeight: 700 }}
                              >
                                Upload MIS File
                              </Typography>
                              <Typography variant="body2" sx={{ color: '#64748b' }}>
                                Supported file types: .xls, .xlsx, .csv
                              </Typography>
                            </>
                          )}
                        </Box>
                      </label>
                    </Box>
                  </Grid>

                  <Grid item xs={12} md={4}>
                    <Button
                      variant="outlined"
                      onClick={handleDownloadTemplate}
                      startIcon={<BiCloudDownload size={20} />}
                      fullWidth
                      sx={{
                        color: '#0284c7',
                        borderColor: '#0284c7',
                        borderRadius: '8px',
                        textTransform: 'none',
                        fontWeight: 600,
                        py: 1.5,
                        '&:hover': {
                          bgcolor: 'rgba(2, 132, 199, 0.05)',
                          borderColor: '#0369a1'
                        }
                      }}
                    >
                      Download Template
                    </Button>
                  </Grid>

                  <Grid item xs={12}>
                    <Box mt={2} textAlign="right">
                      <Button
                        onClick={() => uploadSubmit()}
                        variant="contained"
                        sx={{
                          bgcolor: '#0284c7',
                          color: '#ffffff',
                          borderRadius: '8px',
                          textTransform: 'none',
                          fontWeight: 600,
                          px: 3.5,
                          py: 1,
                          boxShadow: '0 4px 12px rgba(2, 132, 199, 0.25)',
                          '&:hover': {
                            bgcolor: '#0369a1',
                            boxShadow: '0 6px 16px rgba(2, 132, 199, 0.35)'
                          }
                        }}
                      >
                        Submit
                      </Button>
                    </Box>
                  </Grid>
                </Grid>
              )}
            </Card>
          )}

          {/* DISBURSEMENT BASED SECTION */}
          {incentiveTypeValue === 'DISBURSEMENT_BASED' && (
            <Card
              sx={{
                borderRadius: '16px',
                border: '1px solid #e2e8f0',
                boxShadow: '0 4px 20px rgba(0,0,0,0.03)',
                p: { xs: 2.5, md: 3 },
                bgcolor: '#ffffff',
                mb: 3
              }}
            >
              <Stack
                direction="row"
                alignItems="center"
                spacing={1.5}
                sx={{ mb: 2.5, pb: 2, borderBottom: '1px solid #f1f5f9' }}
              >
                <Box
                  sx={{
                    width: 34,
                    height: 34,
                    borderRadius: '8px',
                    bgcolor: '#0284c7',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: '#ffffff'
                  }}
                >
                  <TrendingUpIcon sx={{ fontSize: 18 }} />
                </Box>
                <Box>
                  <Typography sx={{ fontSize: '1rem', fontWeight: 700, color: '#0f172a' }}>
                    Disbursement Based Loan Requirement
                  </Typography>
                  <Typography sx={{ fontSize: '0.75rem', color: '#64748b' }}>
                    Define bank and loan type specific disbursement incentive percentages
                  </Typography>
                </Box>
              </Stack>

              <RadioGroup
                row
                value={selection}
                onChange={handleRadioChange}
                sx={{
                  mb: 3,
                  '& .MuiRadio-root': {
                    color: '#94a3b8',
                    '&.Mui-checked': {
                      color: '#0284c7'
                    }
                  },
                  '& .MuiFormControlLabel-label': {
                    fontWeight: 600,
                    fontSize: '0.875rem',
                    color: '#334155'
                  }
                }}
              >
                <FormControlLabel value="manually" control={<Radio />} label="Manually" />
                <FormControlLabel value="upload" control={<Radio />} label="Upload" />
              </RadioGroup>

              <Grid container spacing={3} mb={3}>
                <Grid item xs={12} sm={6} md={4}>
                  <CustomSelect
                    name="incentiveDuration"
                    label="Incentive Duration"
                    control={control}
                    errors={errors}
                    isRequired
                    options={[
                      { label: 'Monthly', value: 'MONTHLY' },
                      { label: 'Quarterly', value: 'QUARTERLY' },
                      { label: 'Yearly', value: 'YEARLY' }
                    ]}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <CustomInput
                    name="companyPercentage"
                    label="Company Percentage %"
                    control={control}
                    errors={errors}
                    type="number"
                    isRequired
                  />
                </Grid>
              </Grid>

              {selection === 'manually' && (
                <form onSubmit={handleSubmit(onSubmit)}>
                  {disburseFields.map((item, index) => (
                    <Grid container spacing={2} key={item.id} alignItems="flex-end" mb={2}>
                      <Grid item xs={12} sm={4}>
                        <CustomSelect
                          name={`disbursementConfigs.${index}.bankName`}
                          label="Bank"
                          control={control}
                          options={newBankDrop}
                          errors={errors?.disbursementConfigs?.[index]}
                          isRequired
                        />
                      </Grid>

                      <Grid item xs={12} sm={3}>
                        <CustomSelect
                          name={`disbursementConfigs.${index}.loanType`}
                          label="Loan Type"
                          control={control}
                          options={newMasterLoanTypeDrop}
                          errors={errors?.disbursementConfigs?.[index]}
                          isRequired
                        />
                      </Grid>

                      <Grid item xs={12} sm={3}>
                        <Controller
                          name={`targetSlabs.${index}.incentivePercent`}
                          control={control}
                          defaultValue=""
                          render={({ field }) => (
                            <Box>
                              <Typography variant="h6" className="formLabel">
                                Incentive % <span style={{ color: 'red' }}>*</span>
                              </Typography>
                              <TextField
                                {...field}
                                fullWidth
                                placeholder="Enter Incentive %"
                                inputProps={{
                                  maxLength: 2,
                                  inputMode: 'numeric',
                                  pattern: '[0-9]*',
                                  className: 'textInput'
                                }}
                                onChange={(e) => {
                                  const value = e.target.value.replace(/[^0-9]/g, '');
                                  if (value.length > 2) return;
                                  field.onChange(value);
                                }}
                                InputProps={{
                                  endAdornment: <InputAdornment position="end">%</InputAdornment>
                                }}
                              />
                            </Box>
                          )}
                        />
                      </Grid>

                      <Grid item xs={12} sm={2} display="flex" gap={1} pb={0.5}>
                        <IconButton
                          onClick={() =>
                            appendDisburse({
                              bankName: '',
                              loanType: '',
                              incentivePercent: ''
                            })
                          }
                          sx={{
                            bgcolor: '#e0f2fe',
                            color: '#0284c7',
                            borderRadius: '8px',
                            '&:hover': { bgcolor: '#bae6fd' }
                          }}
                        >
                          <MdOutlineAdd />
                        </IconButton>

                        {disburseFields.length > 1 && (
                          <IconButton
                            onClick={() => removeDisburse(index)}
                            sx={{
                              bgcolor: '#fee2e2',
                              color: '#ef4444',
                              borderRadius: '8px',
                              '&:hover': { bgcolor: '#fecaca' }
                            }}
                          >
                            <AiOutlineMinus />
                          </IconButton>
                        )}
                      </Grid>
                    </Grid>
                  ))}

                  <Box mt={3} textAlign="right">
                    <Button
                      variant="contained"
                      type="submit"
                      sx={{
                        bgcolor: '#0284c7',
                        color: '#ffffff',
                        borderRadius: '8px',
                        textTransform: 'none',
                        fontWeight: 600,
                        px: 3.5,
                        py: 1,
                        boxShadow: '0 4px 12px rgba(2, 132, 199, 0.25)',
                        '&:hover': {
                          bgcolor: '#0369a1',
                          boxShadow: '0 6px 16px rgba(2, 132, 199, 0.35)'
                        }
                      }}
                    >
                      Submit
                    </Button>
                  </Box>
                </form>
              )}

              {selection === 'upload' && (
                <Grid container alignItems="center" spacing={3}>
                  <Grid item xs={12} md={8}>
                    <Box
                      sx={{
                        border: '2px dashed #cbd5e1',
                        borderRadius: '12px',
                        p: 3,
                        textAlign: 'center',
                        bgcolor: '#f8fafc',
                        cursor: 'pointer',
                        transition: 'all 0.2s',
                        '&:hover': {
                          borderColor: '#0284c7',
                          bgcolor: '#f0f9ff'
                        }
                      }}
                    >
                      <input
                        accept=".xlsx, .xls, .csv"
                        className="fileInput"
                        id="contained-button-file"
                        multiple
                        type="file"
                        style={{ display: 'none' }}
                        onChange={handleFileChange}
                      />
                      <label
                        htmlFor="contained-button-file"
                        style={{ cursor: 'pointer', display: 'block' }}
                      >
                        <Box>
                          {selectedFileName ? (
                            <Typography variant="body2" sx={{ color: '#0f172a', fontWeight: 600 }}>
                              {`Selected file: ${selectedFileName}`}
                            </Typography>
                          ) : (
                            <>
                              <BiCloudUpload size={36} color="#0284c7" />
                              <Typography
                                variant="h6"
                                sx={{ color: '#0f172a', mt: 1, fontWeight: 700 }}
                              >
                                Upload MIS File
                              </Typography>
                              <Typography variant="body2" sx={{ color: '#64748b' }}>
                                Supported file types: .xls, .xlsx, .csv
                              </Typography>
                            </>
                          )}
                        </Box>
                      </label>
                    </Box>
                  </Grid>

                  <Grid item xs={12} md={4}>
                    <Button
                      variant="outlined"
                      onClick={handleDownloadTemplate}
                      startIcon={<BiCloudDownload size={20} />}
                      fullWidth
                      sx={{
                        color: '#0284c7',
                        borderColor: '#0284c7',
                        borderRadius: '8px',
                        textTransform: 'none',
                        fontWeight: 600,
                        py: 1.5,
                        '&:hover': {
                          bgcolor: 'rgba(2, 132, 199, 0.05)',
                          borderColor: '#0369a1'
                        }
                      }}
                    >
                      Download Template
                    </Button>
                  </Grid>

                  <Grid item xs={12}>
                    <Box mt={2} textAlign="right">
                      <Button
                        onClick={() => uploadSubmit()}
                        variant="contained"
                        sx={{
                          bgcolor: '#0284c7',
                          color: '#ffffff',
                          borderRadius: '8px',
                          textTransform: 'none',
                          fontWeight: 600,
                          px: 3.5,
                          py: 1,
                          boxShadow: '0 4px 12px rgba(2, 132, 199, 0.25)',
                          '&:hover': {
                            bgcolor: '#0369a1',
                            boxShadow: '0 6px 16px rgba(2, 132, 199, 0.35)'
                          }
                        }}
                      >
                        Submit
                      </Button>
                    </Box>
                  </Grid>
                </Grid>
              )}
            </Card>
          )}

          {/* INCENTIVE LIST TABLE CARD */}
          <Card
            sx={{
              borderRadius: '16px',
              border: '1px solid #e2e8f0',
              boxShadow: '0 4px 20px rgba(0,0,0,0.03)',
              p: { xs: 2.5, md: 3 },
              bgcolor: '#ffffff'
            }}
          >
            <Stack
              direction="row"
              alignItems="center"
              spacing={1.5}
              sx={{ mb: 2.5, pb: 2, borderBottom: '1px solid #f1f5f9' }}
            >
              <Box
                sx={{
                  width: 34,
                  height: 34,
                  borderRadius: '8px',
                  bgcolor: '#0284c7',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: '#ffffff'
                }}
              >
                <FormatListBulletedIcon sx={{ fontSize: 18 }} />
              </Box>
              <Box>
                <Typography sx={{ fontSize: '1rem', fontWeight: 700, color: '#0f172a' }}>
                  Incentive List
                </Typography>
                <Typography sx={{ fontSize: '0.75rem', color: '#64748b' }}>
                  Configured incentive rules and parameters
                </Typography>
              </Box>
            </Stack>

            <TableContainer
              sx={{
                border: '1px solid #e2e8f0',
                borderRadius: '12px',
                overflow: 'hidden'
              }}
            >
              <Table>
                <TableHead sx={{ bgcolor: '#f8fafc' }}>
                  <TableRow>
                    <TableCell
                      sx={{
                        color: '#475569',
                        fontWeight: 600,
                        fontSize: '0.75rem',
                        textTransform: 'uppercase',
                        py: 1.5
                      }}
                    >
                      Duration
                    </TableCell>
                    <TableCell
                      sx={{
                        color: '#475569',
                        fontWeight: 600,
                        fontSize: '0.75rem',
                        textTransform: 'uppercase',
                        py: 1.5
                      }}
                    >
                      Company %
                    </TableCell>
                    <TableCell
                      sx={{
                        color: '#475569',
                        fontWeight: 600,
                        fontSize: '0.75rem',
                        textTransform: 'uppercase',
                        py: 1.5
                      }}
                    >
                      Incentive Type
                    </TableCell>
                    <TableCell
                      sx={{
                        color: '#475569',
                        fontWeight: 600,
                        fontSize: '0.75rem',
                        textTransform: 'uppercase',
                        py: 1.5
                      }}
                    >
                      Incentive %
                    </TableCell>
                    <TableCell
                      sx={{
                        color: '#475569',
                        fontWeight: 600,
                        fontSize: '0.75rem',
                        textTransform: 'uppercase',
                        py: 1.5
                      }}
                    >
                      Min Amount
                    </TableCell>
                    <TableCell
                      sx={{
                        color: '#475569',
                        fontWeight: 600,
                        fontSize: '0.75rem',
                        textTransform: 'uppercase',
                        py: 1.5
                      }}
                    >
                      Max Amount
                    </TableCell>
                    <TableCell
                      sx={{
                        color: '#475569',
                        fontWeight: 600,
                        fontSize: '0.75rem',
                        textTransform: 'uppercase',
                        py: 1.5
                      }}
                    >
                      Bank Name
                    </TableCell>
                    <TableCell
                      sx={{
                        color: '#475569',
                        fontWeight: 600,
                        fontSize: '0.75rem',
                        textTransform: 'uppercase',
                        py: 1.5
                      }}
                    >
                      Loan Type
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{
                        color: '#475569',
                        fontWeight: 600,
                        fontSize: '0.75rem',
                        textTransform: 'uppercase',
                        py: 1.5
                      }}
                    >
                      Action
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {IncentiveListData && IncentiveListData.length > 0 ? (
                    IncentiveListData.map((item, index) => (
                      <TableRow
                        key={index}
                        sx={{
                          '&:hover': { bgcolor: '#f8fafc' },
                          '& td': {
                            borderBottom: '1px solid #f1f5f9',
                            py: 1.5,
                            fontSize: '0.8125rem',
                            color: '#1e293b'
                          }
                        }}
                      >
                        <TableCell>{item?.duration || 'N/A'}</TableCell>
                        <TableCell>{item?.companyPercentage ?? 'N/A'}</TableCell>
                        <TableCell>{item?.incentiveType || 'N/A'}</TableCell>
                        <TableCell>
                          {item?.incentivePercent === null || item?.incentivePercent === undefined
                            ? 'N/A'
                            : `${item.incentivePercent}%`}
                        </TableCell>
                        <TableCell>{item?.minAmount || 'N/A'}</TableCell>
                        <TableCell>{item?.maxAmount || 'N/A'}</TableCell>
                        <TableCell>{item?.bankName || 'N/A'}</TableCell>
                        <TableCell>{item?.loanType || 'N/A'}</TableCell>
                        <TableCell align="center">
                          <Tooltip title="Edit Incentive" placement="top" arrow>
                            <IconButton
                              size="small"
                              onClick={() => {
                                navigate(`/users/edit-incentive`, { state: item });
                              }}
                              sx={{
                                bgcolor: '#f0f9ff',
                                color: '#0284c7',
                                border: '1px solid #e0f2fe',
                                borderRadius: '8px',
                                p: 0.75,
                                '&:hover': {
                                  bgcolor: '#0284c7',
                                  color: '#ffffff'
                                }
                              }}
                            >
                              <AiFillEdit size={14} />
                            </IconButton>
                          </Tooltip>
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={9} align="center" sx={{ py: 3, color: '#64748b' }}>
                        No incentive records found
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Card>
        </Container>
      </Box>
    </Page>
  );
}
export default SetIncentiveForEmployeePartner;
